<script setup lang="ts">
import { useDetectOS } from '~/composables/useDetectOS'

defineEmits(['handleClose'])

const { isAppleEcosystem } = useDetectOS()

const appLink = computed(() => {
    return isAppleEcosystem.value
        ? 'https://apps.apple.com/pl/app/iplus/id974674099?l=pl'
        : 'https://play.google.com/store/apps/details?id=pl.plus.plusonline&hl=pl&pli=1'
})
</script>

<template>
    <div
        class="lp-paragraph-md fixed left-0 top-0 z-[60] flex w-screen justify-between bg-plus-lp-grey-100 px-4 py-3 text-plus-lp-dark-blue shadow lg:hidden"
    >
        <div class="flex">
            <button
                class="my-auto mr-2 size-4"
                @click="$emit('handleClose')"
            >
                <img
                    src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/IPlusMobile/Close.svg"
                    alt="close"
                />
            </button>
            <img
                src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/IPlusMobile/pobrane_(1)_1.webp"
                alt="iplus-logo"
                class="my-auto size-10"
            />
            <div class="my-auto ml-2 flex flex-col">
                <p class="lp-label-sm font-medium">Aplikacja iPlus</p>
                <p class="lp-label-sm font-normal">Obsługa konta</p>
            </div>
        </div>
        <PlusBlogLpAtomBaseButton
            class="my-auto h-[33px] text-nowrap bg-plus-lp-white !font-figtree"
            variant="tertiary"
            :to="appLink"
        >
            Pobierz
        </PlusBlogLpAtomBaseButton>
    </div>
</template>
